import { __exports as availablesLocales } from './_virtual-availablesLocales.js';

var hasRequiredAvailablesLocales;

function requireAvailablesLocales () {
	if (hasRequiredAvailablesLocales) return availablesLocales;
	hasRequiredAvailablesLocales = 1;

	Object.defineProperty(availablesLocales, "__esModule", {
	  value: true
	});
	availablesLocales.availablesLocales = availablesLocales$1;
	function availablesLocales$1() {
	  return ['da-dk', 'de-at', 'de-ch', 'de-de', 'en-au', 'en-ca', 'en-gb', 'en-ie', 'en-in', 'en-jp', 'en-nz', 'en-sg', 'en-us', 'es-es', 'es-us', 'fi-fi', 'fr-be', 'fr-ca', 'fr-ch', 'fr-fr', 'it-ch', 'it-it', 'ja-jp', 'nb-no', 'nl-be', 'nl-nl', 'pt-pt', 'sv-se'];
	}
	
	return availablesLocales;
}

export { requireAvailablesLocales as __require };
//# sourceMappingURL=vp-tokenized-fragment-build-services-availablesLocales.js.map
